import type { ErrorReportRow } from './error-report';
import type { ImportSubmitError } from '../types/template';

/** @deprecated Use `ImportSubmitError` from `types/template` directly. */
export type ServerError = ImportSubmitError;

/**
 * Merges client-side and server-side error rows into a single ErrorReportRow[] array.
 * Pure, synchronous, side-effect-free.
 *
 * @param clientRows - Pre-mapped client error rows (already 1-based rowIndex via mapPreviewReport)
 * @param serverErrors - Server rejection errors with 0-based rowIndex into ImportResult.rows
 * @param toFileRow - Translates 0-based ImportResult.rows index → 1-based file row number
 */
export function mapConfirmReport(
  clientRows: ErrorReportRow[],
  serverErrors: ImportSubmitError[] | undefined,
  toFileRow: (zeroBasedIdx: number) => number,
): ErrorReportRow[] {
  if (!serverErrors || serverErrors.length === 0) {
    return [...clientRows].sort((a, b) => a.rowIndex - b.rowIndex);
  }

  const serverRows: ErrorReportRow[] = serverErrors.map((err) => ({
    rowIndex: toFileRow(err.rowIndex),
    data: err.data,
    errorCode: err.errorCode,
    errorMessage: err.errorMessage,
  }));

  return [...clientRows, ...serverRows].sort((a, b) => a.rowIndex - b.rowIndex);
}
